import type { Candidate } from '@entities/candidates';
import type { EntityMetadataItem } from '@shared/ui';
import dayjs from 'dayjs';

type CandidateMetadata = Pick<Candidate, 'id' | 'createdAt' | 'updatedAt'>;

const formatDateTime = (value: string) =>
  dayjs(value).format('DD.MM.YYYY, HH:mm');

export const getEntityMetadata = ({
  id,
  createdAt,
  updatedAt,
}: CandidateMetadata): EntityMetadataItem[] => [
  {
    id: 'id',
    label: 'ID:',
    value: id.toString(),
  },
  {
    id: 'createdAt',
    label: 'Дата создания:',
    value: formatDateTime(createdAt),
  },
  {
    id: 'updatedAt',
    label: 'Дата изменения:',
    value: formatDateTime(updatedAt),
  },
];
